<div class="container-tab-lists new-table-style">

  <div class="inner-tcontainer-tab">
    <div class="header-container">
      <div class="header-left">
        <h2>{{title}} {{isAllLoaded === false ? waitHeader : null}}</h2>
      </div>
    </div>
    <div style="display:flow-root">
      <div style="float:left; width:40vw">
        <app-filter
          [separatorKeysCodes]="separatorKeysCodes"
          [addOnBlur]="addOnBlur"
          [disabled]="isAllLoaded === false"
          [searchItems]="searchItems"
          [selectable]="selectable"
          [removable]="removable"
          [isShowAllEnabled]="isShowAllEnabled"
          (filterChange)="filter = $event"
        ></app-filter>
      </div>
      <div style="text-align:right; float:right">

        @if (isEditModeEnabled && !isExcelModeEnabled && isEditingAllowed()) {
          <a class='kpi-save-menu save-button' title="Save" (click)="onClickSave()">
            <span class='glyphicon glyphicon-floppy-disk'></span> Save
          </a>
        }

        @if (!isEditModeEnabled && canUserRelease() && isEditingAllowed()) {
          <a class='kpi-button-menu' title="Release Mode" (click)="toggleRelease(); isRevokeActive ? toggleRevoke():null" >
            {{releaseButtonText}}
          </a>
        }

        @if (!isEditModeEnabled && canUserRevoke() && showReleaseLabel && isEditingAllowed()) {
          <a class='kpi-button-menu' title="Revoke all released values" (click)="toggleRevoke(); isReleaseActive ? toggleRelease():null ">
            {{revokeButtonText}}
          </a>
        }

        @if (!isExcelModeEnabled && !isEditModeEnabled && !isReleaseActive && !isApprovalModeEnabled && defaults.userCanEditPEReporting() && isEditingAllowed()) {
          <a class='kpi-button-menu' title="Excel" (click)="onClickExcelButton()">
            Excel
          </a>
        }

        @if (isExcelModeEnabled) {
          <a class='kpi-button-menu' title="Download" (click)="downloadExcelInformation()">
            <span class='glyphicon glyphicon-download'></span> Download
          </a>
        }

        @if (isExcelModeEnabled && defaults.userCanEditPEReporting()) {
          <a class='kpi-button-menu' title="Upload" (click)="goUploadFileView()">
            <span class='glyphicon glyphicon-upload'></span> Upload
          </a>
        }

        @if (isExcelModeEnabled) {
          <a class='kpi-button-menu' title="Cancel" (click)="onClickCancelButton()">
            {{'Exit Excel mode'}}
          </a>
        }

        @if (!isApprovalModeEnabled && !isExcelModeEnabled && defaults.userCanEditPEReporting() && isEditingAllowed()) {
          <a class='kpi-button-menu' title="Edit values" (click)="onClickEdit()">
            <span class='glyphicon glyphicon-pencil'></span> {{isEditModeEnabled ? 'Undo' : 'Edit'}}
          </a>
        }

        @if (isShowAllEnabled === false) {
          <a class='kpi-button-menu' title="Show All" (click)="onClickShowAllButton()">
            <span class='glyphicon glyphicon-eye-open'></span> Show All
          </a>
        }

        @if (isShowAllEnabled === true) {
          <a class='kpi-button-menu' title="Hide empty" (click)="onClickShowAllButton()">
            <span class='glyphicon glyphicon-eye-close'></span> Hide empty
          </a>
        }

        <h5>
          @if (isShowAllEnabled === true) {
            <span>Showing all available entries </span>
          }
          @if (isShowAllEnabled === false) {
            <span>Excluding empty values </span>
          }
          @if (showReleaseLabel === true || isEditModeEnabled === true) {
            <span> / </span>
          }
          @if (isEditModeEnabled === true) {
            <span class="salmon-color">Editable kpi values</span>
          }
          @if (showReleaseLabel === true && isEditModeEnabled === true) {
            <span>/</span>
          }
          @if (showReleaseLabel === true) {
            <span class="green-release-color">Released kpi values </span>
          }
        </h5>

        <h5 [style.visibility]="isEditModeEnabled === true ? 'visible' : 'hidden'">
          Edit Mode is enabled. Please click on Save button to save all changes
        </h5>

        @if (!isEditingAllowed()) {
          <h5 class="alert alert-warning" style="color: #721c24; background-color: #f8d7da; border: 1px solid #f5c6cb; padding: 10px; border-radius: 5px;">
            <strong>Notice:</strong>
            This PE is marked as "Not Active" in configuration.
            Editing, Excel, Release and Revoke functions are disabled.
          </h5>
        }
      </div>
    </div>
    <br />

    <pe-quarterreporting-list [list]="list"
      [isEditModeEnabled]="isEditModeEnabled"
      [filter]="filter"
      [isReleaseModeEnabled]="isApprovalModeEnabled"
      [auxFilterPredicate]="auxFilterPredicate"
      [isShowAllEnabled]="isShowAllEnabled"
      [isReleaseActive]="isReleaseActive && !isEditModeEnabled"
      [isRevokeActive]="isRevokeActive && !isEditModeEnabled"
      (onClickRevokeMode)="onClickRevoke()"
    (onClickReleaseMode)="onClickReleaseMode()"></pe-quarterreporting-list>
  </div>
</div>